import { normalizeMyPhone } from "./phone.js";
const HEADER_PHONE = /phone|mobile|no|number|tel/i;
const HEADER_NAME = /name/i;
/**
 * Parse a pasted/uploaded contact list (doc 06 §audiences; R-AUD-3). Tolerates a header
 * row, comma/semicolon/tab separators, and a leading phone column. Normalizes phones to
 * the canonical MY form; unparseable rows are kept with phone=null for the match report.
 */
export function parseContactCsv(text) {
    const lines = (text ?? "")
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean);
    if (lines.length === 0)
        return [];
    const split = (l) => l.split(/[,;\t]/).map((c) => c.trim());
    // Header detection: a first row whose cells are non-numeric labels.
    let phoneIdx = 0;
    let nameIdx = 1;
    let start = 0;
    const first = split(lines[0] ?? "");
    const looksHeader = first.some((c) => HEADER_PHONE.test(c) || HEADER_NAME.test(c)) &&
        !/\d{6,}/.test(lines[0] ?? "");
    if (looksHeader) {
        const p = first.findIndex((c) => HEADER_PHONE.test(c));
        const n = first.findIndex((c) => HEADER_NAME.test(c));
        if (p >= 0)
            phoneIdx = p;
        if (n >= 0)
            nameIdx = n;
        start = 1;
    }
    const rows = [];
    for (let i = start; i < lines.length; i++) {
        const cells = split(lines[i] ?? "");
        const raw = cells[phoneIdx] ?? "";
        if (!raw)
            continue;
        const name = (cells[nameIdx] ?? "").trim() || null;
        rows.push({ raw, phone: normalizeMyPhone(raw), name });
    }
    return rows;
}
/** Summary for the upload match report (doc 06). */
export function csvSummary(rows) {
    const valid = rows.filter((r) => r.phone);
    return { total: rows.length, valid: valid.length, invalid: rows.length - valid.length };
}
//# sourceMappingURL=csv.js.map